import { Card as UiCard } from '@snack-uikit/card';
import { ArrowLinksSVG } from '@snack-uikit/icons';
import { Typography } from '@snack-uikit/typography';
import Link from 'next/link';

import { SOURCE_PLATFORM_QUERY_PARAM_NAME } from '@/constant/routes';
import { useCurrentPlatform } from '@/hooks/useCurrentPlatform';
import { makeStaticImageUrlToConfigsServer } from '@/utils/dynamic';
import { addQueryParamToString, isExternalLink, skipFileExtension } from '@/utils/navigation';

import { Condition } from '../Condition';
import s from './styles.module.scss';

type CardProps = {
  title: string;
  description?: string;
  link: string;
  iconName?: string;
  defaultIconName?: string;
};

export function Card({ title, description = '', link, iconName, defaultIconName }: CardProps) {
  const platform = useCurrentPlatform();

  const linkWithSource = addQueryParamToString(link, SOURCE_PLATFORM_QUERY_PARAM_NAME, platform);

  const replaceTripleDashToLargeDash = (str: string) => str.replace(/-{3,}/g, '—');

  const icon = iconName || defaultIconName;

  return (
    <Link className={s.card_wrapper} href={isExternalLink(link) ? link : skipFileExtension('html', linkWithSource)}>
      <UiCard className={s.card_root} outline>
        <div className={s.card_content_wrapper}>
          <Condition when={Boolean(icon)}>
            <img className={s.card_image} src={makeStaticImageUrlToConfigsServer(icon!)} alt={'service-img'} />
          </Condition>
          <div className={s.card_content}>
            <ArrowLinksSVG className={s.icon} />
            <Typography.SansLabelL className={s.title}>{title} </Typography.SansLabelL>
            <Typography.LightLabelL className={s.description}>
              {replaceTripleDashToLargeDash(description)}
            </Typography.LightLabelL>
          </div>
        </div>
      </UiCard>
    </Link>
  );
}
